import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { Button } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import { useSmartSearchStore } from '~/store/common';

import { PATH } from '~/constants';

import { AiStarsGradientIcon } from '../Icon';

import styles from './SmartSearchButton.module.scss';

const SmartSearchButton = () => {
  const { pathname } = useLocation();

  const mode = useSmartSearchStore((state) => state.mode);
  const { setMode, resetStore } = useSmartSearchStore((state) => state.actions);

  const isDeliveryAgency = pathname.startsWith(PATH.DELIVERY_AGENCY);
  const isActive = mode !== 'closed';

  useEffect(() => {
    if (!isDeliveryAgency && isActive) {
      resetStore();
    }
  }, [isDeliveryAgency]);

  if (!isDeliveryAgency) return null;

  const handleClick = () => {
    if (isActive) {
      resetStore();
    } else {
      setMode('docked');
    }
  };

  return (
    <Button
      className={clsx(styles['smart-search-button'], isActive && styles['active'])}
      variant="outlined"
      color="tertiary"
      size="tiny"
      leftIcon={<AiStarsGradientIcon size={16} />}
      onClick={handleClick}
    >
      스마트 문의하기
    </Button>
  );
};

export default SmartSearchButton;
